import { render, staticRenderFns } from "./VerificationResultsDisplaying.vue?vue&type=template&id=315811ee&scoped=true"
import script from "./VerificationResultsDisplaying.vue?vue&type=script&lang=js"
export * from "./VerificationResultsDisplaying.vue?vue&type=script&lang=js"
import style0 from "./VerificationResultsDisplaying.vue?vue&type=style&index=0&id=315811ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315811ee",
  null
  
)

export default component.exports